import { useEffect, useMemo } from 'react';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import { DEFAULT_ACHATS_CONFIG, normalizeAchatsConfig, buildAchatsEntityPrefixes } from './achatsConfigDefaults';

let hydratePromise = null;

function hydrateAchatsConfig(patchSettings) {
  if (!hydratePromise) {
    hydratePromise = localApiAdapter
      .get('/achats/config')
      .then((response) => {
        const raw = response?.data !== undefined ? response.data : response;
        const normalized = normalizeAchatsConfig(raw || {});
        syncAchatsConfigToSettings(normalized, patchSettings);
        return normalized;
      })
      .catch(() => {
        hydratePromise = null;
        return DEFAULT_ACHATS_CONFIG;
      });
  }
  return hydratePromise;
}

/** Live achats module config — synced from API once, then from SettingsContext. */
export function useAchatsConfig() {
  const { settings, patchSettings } = useSettings();

  useEffect(() => {
    if (settings?.achats && Object.keys(settings.achats).length > 0) return;
    void hydrateAchatsConfig(patchSettings);
  }, [settings?.achats, patchSettings]);

  return useMemo(
    () => normalizeAchatsConfig(settings?.achats || {}),
    [settings?.achats],
  );
}

export function syncAchatsConfigToSettings(config, patchSettings, existingSettings = {}) {
  const normalized = normalizeAchatsConfig(config);
  patchSettings({
    achats: normalized,
    configuration: {
      entityPrefixes: {
        ...(existingSettings?.configuration?.entityPrefixes || {}),
        ...buildAchatsEntityPrefixes(normalized),
      },
    },
  }, { persist: false });
  return normalized;
}
